export default "__VITE_ASSET__CbD5Ixff__"